<template>
	<div class="watch-dashboard">
		<biometric-data-widget :user_uid="user_uid" :watch_id="watch_id" :readings="readings"/>
		<pillbox-widget :user_uid="user_uid" :watch_id="watch_id"/>
		<appointments-widget :user_uid="user_uid" :watch_id="watch_id"/>
		<geo-fencing-widget :user_uid="user_uid" :watch_id="watch_id" :position="position"/>
		<personal-information-widget :user_uid="user_uid" :watch_id="watch_id" :profile="profile"/>
		<time-line-widget :user_uid="user_uid" :watch_id="watch_id"/>
	</div>
</template>

<script>
import Readings from '@/utils/readings'
import Reading from '@/classes/Reading'
import AppointmentsWidget from '@/components/watch/widgets/AppointmentsWidget'
import BiometricDataWidget from '@/components/watch/widgets/BiometricDataWidget'
import GeoFencingWidget from '@/components/watch/widgets/GeoFencingWidget'
import PersonalInformationWidget from '@/components/watch/widgets/PersonalInformationWidget'
import PillboxWidget from '@/components/watch/widgets/PillboxWidget'
import TimeLineWidget from '@/components/watch/widgets/TimeLineWidget'
export default {
	components: {
		AppointmentsWidget,
		BiometricDataWidget,
		GeoFencingWidget,
		PersonalInformationWidget,
		PillboxWidget,
		TimeLineWidget
	},
	props: [
		'user_uid',
		'watch_id',
		'profile'
	],
	data () {
		return {
			name: 'watch dashboard biometric',
			readings: {
				loading: false,
				data: [],
				error: null
			},
			position: {
				loading: false,
				data: null,
				error: null
			}
		}
	},
	watch: {
		'$route' () {
			this.getReadings()
		}
	},
	methods: {
		comparator (a, b) {
			if (a.type_id < b.type_id) return -1
			if (a.type_id > b.type_id) return 1
			return 0
		},
		getReadings () {
			this.readings.loading = true
			this.position.loading = true
			this.readings.data = []
			this.position.data = null
			this.$api.readings.getLast(this, this.user_uid, this.watch_id)
				.then(response => {
					this.$log.info(this.name, 'readings.getLast OK', response)()
					let readings = []
					let position = null
					response.body.forEach(element => {
						switch (element.type_id) {
							case Readings.TYPE_GEOFENCING:
								position = new Reading(element)
								break
							default:
								readings.push(new Reading(element))
						}
					})
					this.readings.data = readings
					this.readings.data.sort(this.comparator)
					this.position.data = position
				}).catch(error => {
					this.$log.error(this.name, 'readings.getLast ERROR', error)()
					this.readings.error = error
					this.position.error = error
				}).finally(() => {
					this.readings.loading = false
					this.position.loading = false
				})
		}
	},
	beforeCreate () {
		this.$title('Watch Dashboard')
	},
	mounted () {
		this.getReadings()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/WatchDashboard.vue